export default function RelativeRiskDetailsDirective() {
  return {
    template: require('./relative-risk-details.html'),
    scope: {
      process: '=',
      isEditable: '@',
      isDialog: '@',
      tooltipAppendToSelector: '@',
    },
    controller: 'RelativeRiskDetailsController',
    controllerAs: 'relativeRiskDetailsVM',
    bindToController: true,
    replace: true,
  };
}
